import RowButton from 'components/atoms/row-button'
import React from 'react'
import PropTypes from 'prop-types'
import CmsFeaturedSellerBioService from 'domains/cms-featured-seller/services/bio-service'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'


const propTypes = {
  buttonText    : PropTypes.string,
  buttonColour  : PropTypes.string,
  onButtonClick : PropTypes.func
}

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

/**
 * Columns definition for Cms Fs Table
 * @param {string} buttonText - The text that appears at the button on each row
 * @param {string} buttonColour - Bootstrap button type class name (eg. primary)
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const CmsFeaturedSellerTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick
}) => {

  const BioCell    = (row) => CmsFeaturedSellerBioService.format(row.cell.value)
  const UrlKeyCell = (row) => (
    <a
      className='text-primary'
      href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/featured-sellers/${row.cell.value}` }
      target='_blank' rel='noopener noreferrer'
    >
      { `featured-sellers/${row.cell.value}` }
    </a>
  )

  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      data={ row.original }
      color={ buttonColour }
      onClick={ onButtonClick }
      text={ buttonText }
    />
  )

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header  : 'Seller',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'seller.id',
            disableFilters : true
          },
          {
            Header   : 'Name',
            accessor : 'seller.name',
            id       : 'seller_name'
          },
          {
            Header   : 'Url Key',
            accessor : 'seller.url_key',
            id       : 'seller_url_key',
            Cell     : UrlKeyCell
          }
        ]
      },
      {
        Header  : 'Closet',
        columns : [ {
          Header         : 'Occupation',
          accessor       : 'occupation',
          disableFilters : true
        },
        {
          Header         : 'Bio',
          accessor       : 'bio',
          disableFilters : true,
          Cell           : BioCell
        },
        {
          Header : 'Action',
          id     : 'action',
          Cell   : ActionCell
        } ]
      }
    ]
  )
}

CmsFeaturedSellerTableColumns.propTypes = propTypes

export default CmsFeaturedSellerTableColumns
